import {AppliedTo} from "../enums/enums";

export const tagSchema = () => {
    return (
        {
            name: {
                type: 'text',
                label: 'Name',
                validation: (value) => {
                    if (value.trim() === '') return 'Name is required';
                    return null;
                },
            },
            // image: {
            //     type: 'text',
            //     label: 'Image',
            // },
            description: {
                type: 'textarea',
                label: 'Description',
            },
            status: {
                type: 'checkbox',
                label: 'Status',
                columns: {md: 6},
                validation: (value) => {
                    return null;
                },
            },
            showInReport: {
                type: 'checkbox',
                label: 'Show in report',
                columns: {md: 6},
                validation: (value) => {
                    return null;
                },
            }
        }
    )
}

export const assignTagSchema = ({list, products}) => {
    const {
        items: productList,
        status: productListStatus,
    } = list.product;

    //Unassigned product list
    const unassignedProductMap = Object.fromEntries(
        Object.entries(productList || {}).filter(([id]) => !products.includes(id))
    );
    return (
        {
            products: {
                type: 'multiselect',
                label: 'Assign to',
                options: productListStatus === "success" ? unassignedProductMap : {},
                columns: {md: 12, lg: 6},
                isSearch: true,
                searchPlaceholder: 'Search "Tags"',
                validation: (value) => {
                    if (!Array.isArray(value) || value.length === 0) return 'At least one product is required';
                    return null;
                },
            },
            apply: {
                type: 'select',
                label: 'Apply to',
                options: AppliedTo,
                columns: {md: 12, lg: 6},
                enums: true,
            },
        }
    )
}

export const unassignedTagSchema = ({list, products}) => {
    const {
        items: productList,
        status: productListStatus,
    } = list.product;

    //Assigned products list
    const assignedProductMap = Object.fromEntries(
        Object.entries(productList || {}).filter(([id]) => products.includes(id))
    );
    return (
        {
            products: {
                type: 'multiselect',
                label: 'Remove from',
                options: productListStatus === "success" ? assignedProductMap : {},
                columns: {md: 12, lg: 6},
                isSearch: true,
                searchPlaceholder: 'Search "Tags"',
                validation: (value) => {
                    if (!Array.isArray(value) || value.length === 0) return 'At least one product is required';
                    return null;
                },
            },
            apply: {
                type: 'select',
                label: 'Apply to',
                options: AppliedTo,
                columns: {md: 12, lg: 6},
                enums: true,
            },
        }
    )
}
